import { render, staticRenderFns } from "./dashboard-employee.vue?vue&type=template&id=05351617&scoped=true"
import script from "./dashboard-employee.vue?vue&type=script&lang=js"
export * from "./dashboard-employee.vue?vue&type=script&lang=js"
import style0 from "./dashboard-employee.vue?vue&type=style&index=0&id=05351617&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05351617",
  null
  
)

export default component.exports